// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__35dBO","range":"MonthRangeSwitch_range__2pdq1","disabled":"MonthRangeSwitch_disabled__3uOTl"};